import type { CrmOrg } from '../../../types/CrmOrgs';
import type { VisibilityMap } from '../../../types/VisibilityTypes';
import { useCallback } from 'react';

export const useGetTopTag = (visibilityMap: VisibilityMap, crmOrgs?: CrmOrg[]) => {
  return useCallback(
    (crmOrgId: string) => {
      return visibilityMap.ENVIRONMENTS && crmOrgId && crmOrgs
        ? crmOrgs.find((org) => org.id === crmOrgId)?.name
        : undefined;
    },
    [crmOrgs, visibilityMap],
  );
};
